import React, { Component } from 'react';
import './App.css';
import TryOnPage from './pages/TryOnPage';
import { Box, Columns, Container, Content, Hero, Navbar } from 'react-bulma-components/full';
import { fitWebcam } from '@facecake/fmt-react-tryon';

var isMobile = require('is-mobile');
var toPx = require('to-px');

class App extends Component {
  state = {
    currentProductType: 'blush',
    currentProductHeaderUrl: 'https://demos.facecake.com/blushing/images/ui/blushing_logo_header.png',
    currentProductHeaderColor: '#f78ea2',
  }

  changeTheme = productType => {
    let titleImage, backgroundImage;
    switch (productType) {
      case 'blush':
        titleImage = './images/ui/btn_toggle_beauty.png';
        backgroundImage = './images/backgrounds/beauty_bg.png';
        this.setState({
          currentProductHeaderUrl: 'https://demos.facecake.com/blushing/images/ui/blushing_logo_header.png',
          currentProductHeaderColor: '#f78ea2',
          });
        break;
      case 'earrings':
        titleImage = './images/ui/btn_toggle_earrings.png';
        backgroundImage = './images/backgrounds/dangle_bg.png';
        this.setState({
          currentProductHeaderUrl: 'https://demos.facecake.com/blushing/images/ui/dangle_logo_header.png',
          currentProductHeaderColor: '#3646c3',
          });
        break;
      case 'glasses':
        titleImage = './images/ui/logo_header_glasses.png';
        backgroundImage = './images/backgrounds/glasses_bg.png';
        this.setState({
          currentProductHeaderUrl: 'https://demos.facecake.com/blushing/images/ui/shadesAR_logo_header.png',
          currentProductHeaderColor: '#93c32f',
          });
        break;
      default:
    }
    if (document.querySelector('#titleImage')) { document.querySelector('#titleImage').src = titleImage; }
    document.querySelector('.hero-background-image').style.backgroundImage = `url(${backgroundImage})`;
    this.setState({currentProductType: productType});
  }

  render() {
    const fittdedWebcam = fitWebcam();
    const screenWidth = window.screen.width;
    const maxWidth = (fittdedWebcam.width + toPx('2.5rem') < screenWidth) ? fittdedWebcam.width + toPx('2.5rem') : screenWidth;

    return (
      <Hero size="fullheight">
        <Hero.Head renderAs="header" className="is-hidden-mobile">
        </Hero.Head>
        <Hero.Body>
          <Container className="has-text-centered is-paddingless" style={{maxWidth: maxWidth}}>
            <Columns centered>
              <Box style={{maxWidth: isMobile() ? '100%' : maxWidth, padding: isMobile() ? '0px 0px 1.5rem' : ''}}>
                <Container className="is-vcentered" style={{ width: '100%', paddingBottom: '0.5rem' }}>
                  <Navbar style={{ display: 'block', paddingTop: isMobile() ? '1rem' : '0.3rem', backgroundColor: this.state.currentProductHeaderColor, textAlign: 'center' }} >
                      <img style={{ margin: 'auto 1rem', maxHeight: '3rem'}} src={this.state.currentProductHeaderUrl} alt="FaceCake"/>
                  </Navbar>
                </Container>
                <Container style={{ width: '100%'}}>
                {/* 
                // NOTE: This is the HTML element where the Try-On is rendered. It's outside the <TryOnPage> component
                // NOTE: to prevent rerendering no every state change. It's loaded in <TryOnPage>'s componentDidMount()
                */}
                <div id="try-on-container"></div>
                <TryOnPage productType={this.state.currentProductType} />

                </Container>
              </Box>
            </Columns>
          </Container>
        </Hero.Body>
        <Hero.Footer>
          <Content>
            <a href="https://facecake.com" target="_blank" rel="noopener noreferrer">
              <img src="https://demos.facecake.com/blushing/images/ui/facecake_logo.png" alt="facecake" />
            </a>
            <br />
            <a href="https://facecake.com/privacy-policy.html" target="_blank" rel="noopener noreferrer">PRIVACY POLICY</a>
          </Content>
        </Hero.Footer>
      </Hero>
    )
  }
}

export default App;
